/**
 * The Documents row menu's project rows (card 4.1): "Add to project ›" /
 * "Remove from <project>" for a page or folder of this section. A personal or
 * on-device section takes personal projects, a team section its team's.
 * A project member also gets "Move to space �" (card 4.3).
 */
import React, { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { FolderInput, FolderMinus, FolderPlus } from 'lucide-react';
import { useProjectFilterScope } from '../../scope/projectMembership';
import { useProjectScopeStore } from '../../scope/projectScopeStore';
import { addItemToProject, removeItemFromProject } from '../../scope/projectItems';
import { projectMenuRows } from '../../scope/projectMenuRows';
import { docNodeId } from './documentsProjectFilter';
import { docSpaceMenuRows } from '../../scope/docSpaceMenuRows';
import { moveNodeToSpace } from '../../scope/docSpaceActions';
import useDocSpaces from './useDocSpaces';

export const docWireScope = (scope) => (scope?.type === 'team' && scope.teamId != null ? `team:${scope.teamId}` : 'personal');

const addIcon = <FolderPlus size={14} />;
const removeIcon = <FolderMinus size={14} />;
const spaceIcon = <FolderInput size={14} />;
const warn = (err) => console.warn('[project-scope] document membership failed:', err);

export default function useDocProjectRows(scope) {
  const { t } = useTranslation();
  const filter = useProjectFilterScope();
  const projects = useProjectScopeStore((s) => s.known.projects);
  const links = useProjectScopeStore((s) => s.known.links);
  const docSpaces = useDocSpaces();
  return useCallback(
    (node) => {
      if (!node) return [];
      const nodeId = docNodeId(node);
      const wireScope = docWireScope(scope);
      const project = docSpaces.project;
      const spaceRows = docSpaceMenuRows({
        nodeId,
        isMember: Boolean(project) && filter.memberIds.has(nodeId),
        spaces: docSpaces.spaces,
        assignment: docSpaces.assignment,
        labels: { move: t('docSidebar.spaces.moveToSpace'), main: t('docSidebar.spaces.main') },
        icon: spaceIcon,
        onMove: (spaceId) => moveNodeToSpace(project, nodeId, spaceId).catch(warn),
      });
      const rows = projectMenuRows({
        nodeId,
        wireScope,
        activeProject: filter.activeProject,
        memberIds: filter.memberIds,
        projects,
        links,
        labels: { add: t('docSidebar.menu.addToProject'), remove: (name) => t('docSidebar.menu.removeFromProject', { name }) },
        icons: { add: addIcon, remove: removeIcon },
        onAdd: (p) => addItemToProject(p, nodeId, wireScope).catch(warn),
        onRemove: (p) => removeItemFromProject(p, nodeId).catch(warn),
      });
      return [...spaceRows, ...rows];
    },
    [scope, filter, projects, links, docSpaces, t]
  );
}
